<div class="modal-header">
  <h4 class="modal-title" id="modal-basic-title">{{title}}</h4>
  <button type="button" class="btn-close" aria-label="Close" (click)="close()"></button>
</div>

<div class="modal-body">
  <div class="card card-toolbar">
    <div class="card-body">
      <div class="row align-items-center mb-3 pb-3 border-bottom">
        <div class="col-sm-12 col-md-6 col-lg-3 col-xl-3">
          <app-date-range-select [startDate]="searchCriteria.startDate" [endDate]="searchCriteria.endDate" [dateRange]="'thisyear'" [dateTitle]="dateTitle" (valueChange)="changedDate($event)">
          </app-date-range-select>
        </div>
        <div class="col-sm-12 col-md-4 col-lg-3 col-xl-3" *ngIf="stores.length>1">
          <div class="form-group mb-0">
            <label class="custom-form-label" for="storeInput">{{'store.storeName' | translate}}</label>
            <ng-multiselect-dropdown class="custom-multi-select" [settings]="storeDropdownSettings" [data]="stores" [(ngModel)]="selectedStores">
            </ng-multiselect-dropdown>
          </div>
        </div>
        <div class="col-sm-12 col-md-6 col-lg-3 col-xl-3 d-flex gap-2 align-items-center">
          <input class="form-control flex-grow-1" type="text" name="search" [(ngModel)]="searchText" placeholder="{{'hint.search-in-result' | translate}}" appUppercase autocompleteOff>
          <app-modify-column-widget [screenCode]="screenCode" [cols]="cols" (valueChange)="setSelectedColumns()">
          </app-modify-column-widget>
        </div>
</div>

      <p-table #dt [loading]="loading" [columns]="selectedColumns" [value]="dataList | searchGlobal: searchText" sortField="id" sortOrder="-1" [responsive]="true" [paginator]="true" [rows]="10"
        [resizableColumns]="false" [reorderableColumns]="true" [exportFilename]="'customer_has_debt'" [showCurrentPageReport]="true" [rowsPerPageOptions]="[5,10,15,25,50,100]"
        currentPageReportTemplate="{first} - {last} of {totalRecords}">
        <ng-template pTemplate="header" let-columns>
          <tr>
            <th *ngFor="let col of columns" [pSortableColumn]="col.field" pResizableColumn pReorderableColumn>
              <app-table-headers-generic [col]="col"></app-table-headers-generic>
            </th>
            <th></th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-rowData let-columns="columns" let-rowIndex="rowIndex">
          <tr [pSelectableRow]="rowData" [pSelectableRowIndex]="rowIndex" (dblclick)="onRowDblClick(rowData)">
            <hr class="d-sm-none solid">
            <td *ngFor="let col of columns">
              <app-table-columns-generic [data]="rowData[col.field]" [format]="col"></app-table-columns-generic>
            </td>
            <td>
              <app-phone-call-option-widget [phoneNumber]="rowData.incomingNo" [customerId]="rowData.customerId"></app-phone-call-option-widget>
              <button *ngIf="rowData.customerId>0" class="btn btn-xs-block btn-primary btn-sm" (click)="onRowDblClick(rowData)">
                {{'button.customer-detail' | translate}}
              </button>
              <button *ngIf="rowData.customerId==0" class="btn btn-table btn-xs-block btn-outline-primary btn-sm" (click)="onRowDblClick(rowData)">
                {{'button.new-customer' | translate}}
              </button>
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="footer" let-columns>
          <tr>
            <td *ngFor="let col of columns">
              <app-table-footer-columns-generic [dataList]="dataList" [col]="col"></app-table-footer-columns-generic>
            </td>
            <td></td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>
</div>

<div class="modal-footer">
  <button type="button" class="btn btn-secondary" (click)="close()">
    {{'button.close' | translate}}
  </button>
  <div class="d-inline-flex align-items-center gap-1" role="group" aria-label="export">
    <button type="button" class="btn btn-outline-success btn-sm" (click)="exportFile(exportFileTypeEnum.EXCEL)" triggers="mouseenter:mouseleave" placement="top" container="body" [ngbPopover]="'button.export-to-excel'| translate">
    <i class="fa fas fa-file-excel" aria-hidden="true"></i>
  </button>
    <button type="button" class="btn btn-outline-danger btn-sm" (click)="exportFile(exportFileTypeEnum.PDF)" triggers="mouseenter:mouseleave" placement="top" container="body" [ngbPopover]="'button.export-to-pdf'| translate">
    <i class="fa fas fa-file-pdf" aria-hidden="true"></i>
  </button>
  </div>
  <button type="button" class="btn btn-outline-primary" (click)="openVoipCallImport()">
    {{ 'button.import-voip-call' | translate}}
  </button>
  <button type="button" class="btn btn-primary" (click)="getReport()">
    <i class="fa fas fa-sync-alt" aria-hidden="true"></i>
    {{ 'button.refresh' | translate}}
  </button>
</div>